import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import devImg from "../../assests/ArServicesImg/arvr-dev.svg";
import growthImg from "../../assests/ArServicesImg/arvr-growth.svg";

import "./ARVRDevelopment.css";

const ARVRDevelopment: React.FC = () => {
  return (
    <div style={{display:"flex",justifyContent:"center"}}>
    <div className="container-development py-5">
      {/* Top Section */}
      <div className="row bg-light-purple rounded shadow p-4 mb-4 align-items-center top-section">
        <div className="col-md-5 text-center mb-3 mb-md-0">
          <img src={devImg} alt="AR/VR Dev" className="img-fluid" />
        </div>
        <div className="col-md-7 development-card">
          <h5 className="development-h5">Custom AR/VR Development</h5>
          <ul className="development-ul">
            <li>Develop <span className="bold-span">tailored AR/VR applications </span>for enterprise, training, marketing, and simulation use cases. </li>
            <li>Leverage <span className="bold-span">immersive technologies</span> to boost engagement and business outcomes. </li>
            {/* <li>Scalable infrastructure for large user adoption</li>
            <li>3D modeling, animation, and environment design</li> */}
          </ul>
        </div>
        <hr className="custom-hr" />
        <div className="col-md-7 mb-3 mb-md-0 development-card">
          <h5 className="development-h5">Immersive Training & Collaboration </h5>
          <ul className="development-ul">
            <li>Design <span className="bold-span">interactive AR/VR training programs</span> for employees, enhancing skill development. </li>
            <li>Improve collaboration with <span className="bold-span">virtual environments for team-based projects</span>. </li>
            {/* <li>
              Stronger Customer Engagement through interactive experiences.
            </li>
            <li>Faster Decision-Making using<span className="bold-span"> real-time AR insights</span>.</li> */}
          </ul>
        </div>
        <div className="col-md-5 text-center">
          <img src={growthImg} alt="Business Growth" className="img-fluid" />
        </div>
      </div>
    </div>
    </div>
  );
};

export default ARVRDevelopment;
